class MobileNavigation {
  constructor() {
    this.menuToggle = document.querySelector(".touch-manipulation")
    this.header = document.querySelector("header")
    // this.mobileMenuElement = null
    this.topBar = document.querySelector(".top-bar")
    this.headerMenu = document.querySelector(".header-menu")
    this.headerMenuContent = document.querySelector(".header-menu-content")
    this.logoWrapper = document.querySelector(".logo-wrapper")
    this.logoImg = document.querySelector(".logo-img")
    this.mobileMenu = document.querySelector(".mobile-menu")

    this.toggleMobileMenu()
    this.handleScroll()
  }

handleScroll() {
  window.addEventListener("scroll", () => {
    const isScrolled = this.header.classList.toggle("is-scrolled", window.scrollY > 50)
    if(isScrolled) {
        this.hideTopBar()
    }else{
        this.showTopBar()
    }

  })
}

hideTopBar() {
    if (this.topBar) {
        this.topBar.classList.add("h-0", "overflow-hidden", "opacity-0")
        this.headerMenu.classList.remove("py-1", "sm:py-2")
        this.headerMenuContent.classList.remove("sm:h-16", "md:h-20")
        this.headerMenu.classList.add("pt-0")
        this.logoWrapper.classList.remove("p-1.5", "sm:p-2")
        this.logoWrapper.classList.add("p-1")
        this.logoImg.classList.remove("h-8", "sm:h-10", "md:h-12")
        this.logoImg.classList.add("h-7", "sm:h-8")
    }
}

showTopBar() {
    if (this.topBar) {
        this.topBar.classList.remove("h-0", "overflow-hidden", "opacity-0")
        this.headerMenu.classList.add("py-1", "sm:py-2")
        this.headerMenuContent.classList.add("sm:h-16", "md:h-20")
        this.headerMenu.classList.remove("pt-0")
        this.logoWrapper.classList.remove("p-1")
        this.logoWrapper.classList.add("p-1.5", "sm:p-2")
        this.logoImg.classList.remove("h-7", "sm:h-8")
        this.logoImg.classList.add("h-8", "sm:h-10", "md:h-12")
        
    }
}


toggleMobileMenu() {
  this.menuToggle.addEventListener("click", () => {
    const isOpen = this.menuToggle.classList.toggle("opened")

    if (isOpen) {
      this.openMenu()
    } else {
      this.closeMenu()
    }
  })
}


openMenu() {
    this.menuToggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>'
    this.mobileMenu.classList.remove("animate-fade-in-up")
    this.mobileMenu.classList.remove("hidden")
    this.mobileMenu.classList.add("animate-fade-in-down")
  }
closeMenu() {
    this.menuToggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-menu" aria-hidden="true"><path d="M4 5h16"></path><path d="M4 12h16"></path><path d="M4 19h16"></path></svg>'
    this.mobileMenu.classList.remove("animate-fade-in-down")
    this.mobileMenu.classList.add("animate-fade-in-up")
    this.mobileMenu.classList.add("hidden")
    // setTimeout(() => {
    //     this.mobileMenu.classList.add("hidden")
    // }, 600)
  }

}

export default MobileNavigation